var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVendorRegisterIcon = function SvgVendorRegisterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M3.332 15h2.257a6.667 6.667 0 1 0 0-10H3.332a8.32 8.32 0 0 1 6.667-3.334 8.333 8.333 0 0 1 8.333 8.333 8.333 8.333 0 0 1-15 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M.022 10.832H6.69v2.5l4.166-3.333L6.69 6.665v2.5H.022z"
  })));
};
export default SvgVendorRegisterIcon;